import React, { useState, useMemo, useRef, useEffect } from 'react';
import {EuiFlexGroup, EuiBasicTable, EuiHealth,  EuiFlexItem, EuiFormRow, EuiLoadingSpinner, EuiText, EuiButtonIcon, CENTER_ALIGNMENT, SortDirection} from '@elastic/eui';
import moment from 'moment';

import './styles.css';
import { SelectorTiposContenidoContainer as SelectorTiposContenido } from '../../../../components/Selectores/TiposContenidoPeriodoAbierto/container';

import { Action } from '../../../../components/Menus/interface';
import { Menu } from '../../../../components/Menus';
import { DetalleContent } from '../Components/detalleContent';
import { TablaValidaciones } from '../Components/tablaValidaciones';
import { useUserSettings } from '../../../../context/CurrentUserContext';

import ModalYesNoText from '../../../../components/Modal/YesNoText';


interface dataRequest {IdTipo: string}
interface dataValidarRequest{IdTipo: string, Validar: boolean, IdCentro: string, ValidarCG: boolean, ValidacionFinal: boolean, ForzarValidacion: boolean}

interface Props {
  onFilter(data: dataRequest): void;
  onValidar(data: dataValidarRequest): void;
  onDetalleFilter(data: any): void;
  onComprobarValidar(data: any): void;
  data: any;
  dataDetalle: any;
  isLoading: boolean;
  textoValidacion: any;
}

export const ValidacionDNScreen = (props: Props) => {
  let {currentUser} = useUserSettings()  as any;

  let { onFilter, onValidar, onDetalleFilter, onComprobarValidar,  data, dataDetalle, isLoading, textoValidacion } = props;
  const ref:any = useRef();
  
  const [tipocontenido, setTipoContenido] = useState<any>(undefined);
  const [validar, setValidar] = useState<boolean>((data.length > 0 && data.filter((x: any) => x.validado == false).length == 0 ? false : true));
  
  // const [idCentro, setIdCentro] = useState<any>(undefined);
  const [usrCG, setUsrCG] = useState<boolean>(['CG','IT'].includes(currentUser.perfil))
  const [usrDN, setUsrDN] = useState<boolean>(['DN_ADMON'].includes(currentUser.perfil))
  const [validaFinal, setValidaFinal] = useState<boolean>((data.length > 0 && data.filter((x: any) => x.validacionFinal == true).length > 0 && usrCG ? true : false));
  const [openRemoveModal, setOpenRemoveModal] = useState(false);
  const [valReqData, setValReqData] = useState<any>(undefined);

  useMemo(()=>{
    setValidar((data.length > 0 && data.filter((x: any) => x.validado == false).length == 0 ? false : true));
    setValidaFinal((data.length > 0 && data.filter((x: any) => x.validacionFinal == true).length > 0 && usrCG ? true : false));
  },[data])

  useEffect(()=>{
    if(textoValidacion != ""){
      setOpenRemoveModal(true)
    }
  },[textoValidacion]);

  const onTipoContenidoChange = (value: any) => {
    setTipoContenido(value);
  }

  const getRequesData = () => {
    const reqdata : dataRequest = {
      IdTipo: tipocontenido
    }
    return (
      reqdata
    )
  }

  const getValidarRequesData = (pInvalidar: boolean, pIdCentro: any, pValidarCG: any, pValidacionFinal: any) => {
    const reqdata : dataValidarRequest = {
      IdTipo: tipocontenido,
      Validar: (pValidacionFinal ? !validaFinal : !pInvalidar), //(pInvalidar ?  false : (pValidacionFinal ? validaFinal : validar)),
      IdCentro: pIdCentro,
      ValidarCG: pValidarCG,
      ValidacionFinal: pValidacionFinal,
      ForzarValidacion: false
    }
    return (
      reqdata
    )
  }

  const onFiltrar = () =>{
    onFilter(getRequesData());
  }  

  const onValidarClick = () => {
    // onValidar(getValidarRequesData(false, undefined, (usrCG ? true : false), (usrCG ? true : false)));
    // setOpenRemoveModal(true)
    onComprobarValidar(getValidarRequesData(false, undefined, (usrCG ? true : false), (usrCG ? true : false)));
    setValReqData(getValidarRequesData(false, undefined, (usrCG ? true : false), (usrCG ? true : false)));
  }

  const onInvalidar = (pIdCentro: any, pValidarCG: any) => {
    onValidar(getValidarRequesData(true, pIdCentro, pValidarCG, false));
  }

  const onValidarCG = (pIdCentro: any, pValidarCG: any) => {
    // onValidar(getValidarRequesData(false, pIdCentro, pValidarCG, false));
    onComprobarValidar(getValidarRequesData(false, pIdCentro, pValidarCG, false));
    setValReqData(getValidarRequesData(false, pIdCentro, pValidarCG, false));
  }

  const onConfirmValidate = (response:any) => {
    if(response!==undefined && response === true){
      var vReqData = valReqData;
      vReqData.ForzarValidacion = true;
      onValidar(vReqData);
      setOpenRemoveModal(false)
      
    }else{
      setOpenRemoveModal(false)
      onFiltrar()
    }
  }

  const Actions: Action[] = useMemo(()=>[    
    {handle:onValidarClick,text: (validaFinal? "Invalidar" : "Validar"),size:"s", isDisabled: data.length == 0 || isLoading || (!usrCG && !validar)},
    {handle:onFiltrar,text:"Filtrar",size:"s", isDisabled: isLoading}
  ],[onFiltrar, onValidarClick, data, validaFinal])

  return (
    <>
      <EuiFlexGroup style={{height:'100%'}} className={"collapsePanel"}>
        <EuiFlexItem>
            <EuiFormRow>
              <SelectorTiposContenido valueOfSelected={tipocontenido} onChange={onTipoContenidoChange} />
            </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem style={{height: "100%",padding: "0.2rem", overflow:"hidden", marginBottom:'5px'}}>
          <EuiFlexGroup alignItems='baseline'>
            <EuiFlexItem>
            <EuiFlexGroup alignItems='center' >
              <EuiFlexItem grow={false}>
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
              </EuiFlexItem>
              <EuiFlexItem>
                <Menu actions={Actions}/>
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
          </EuiFlexGroup>
          <EuiFlexGroup style={{height:'95%', flexDirection:'column'}}>
              <EuiFlexItem grow={false} style={{marginBottom:'0', alignItems: 'center', overflowX:'auto', overflowY:'auto'}}>
                {isLoading && <EuiLoadingSpinner size="xl" />}
                {!isLoading && data.length > 0 && 
                <TablaValidaciones data={data} onInvalidar={onInvalidar} todosValidados={!validar} onValidarCG={onValidarCG} usrCG={usrCG} usrDN={usrDN} validaFinal={validaFinal} onDetalleFilter={onDetalleFilter} tipoContenido={tipocontenido}/>
                }
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
          </EuiFlexGroup>
          {openRemoveModal ? <ModalYesNoText onClose={onConfirmValidate} isOpen={openRemoveModal} text={"Tiene el siguiente problema:" + textoValidacion +" ¿Desea validar de todas formas?"} title={"Forzar validación"}/> : null}
    </>
  );
};

export default ValidacionDNScreen;
